import equal from 'fast-deep-equal';
import {ItemsTileHelper} from '../ItemsTileHelper';

export abstract class ItemsTileItem {

  protected config = undefined;
  protected latLngs = undefined;

  protected constructor(config) {
    this.config = config;
    this.latLngs = this.parseLatLngs();
  }

  public isEqual(item) {
    return equal(this.config, item.config);
  }

  public abstract getId();

  public calculateTiles() {
    const figure = this.createTurfFigure();
    return ItemsTileHelper.calculateFigureTiles(figure);
  }

  public abstract draw(context, tile, offsetX, offsetY);

  protected latLngToCanvasXY(tile, latLng) {
    return tile.latLngToTileXY(latLng);
  }

  protected abstract parseLatLngs();

  protected abstract createTurfFigure();
}
